// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2oEgv","content":"LoadingAlert_content__3Yx3i"};